// extracted by mini-css-extract-plugin
export default {"container":"PopUpModal_container__cLGgT","closeModalIcon":"PopUpModal_closeModalIcon__Bzi3i"};